var Info = function() {
    this.id = "";
    this.name = "";
    this.value = "";
    this.type = "";
};
Info.BOOLEAN = "boolean"; // Read 0|1 or false|true and displayed as yes|no
Info.DISTANCE = "distance"; // stored in meters, displayed in km, mi, nmi...
Info.ELEVATION = "elevation"; // stored in meters
Info.PHONE = "phone"; // text
Info.MOBILE = "mobile";  // text
Info.ADDRESS = "address";  // text
Info.EMAIL = "email";  // text
Info.URL = "url"; // text
Info.FAX = "fax";  // text
Info.TEXT = "text";  // text
Info.DATE = "date";  // text representing a date
Info.TIME = "time";  // text representing time
Info.DATE_TIME = "date_time";  // text representing date and time
Info.DURATION = "duration";  // duration stored in minutes, displayed in hh:mm
Info.POSITION = "position";  // position stored as lat long: 45.4, 45,4
Info.TWITTER = "twitter";  // twitter account
Info.FACEBOOK = "facebook";  // facebook account
Info.PAYMENT_METHOD = "payment_method";  // mc, visa, cash, amex, interac, etc.
Info.TRAIL_STATUS = "trailStatus"; // open, closed, warning...
Info.CHART = "chart";
Info.WEIGHT = "weight";

export default Info